import Image from 'next/image';
import Link from 'next/link';
import React from 'react';

const WhyChooseMowebFintech = () => {
    return (
        <div className="section-py">
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="lg:col-span-10 pb-10">
                        <h2 className="mb-3">Why Choose Moweb?</h2>
                        <p className="mb-3">
                            We&apos;re more than just a fintech software development company—we&apos;re your long-term innovation
                            partner.
                        </p>
                        <p className="text-textcolor mb-0 fw-700 fs-lg">Here&apos;s why businesses choose Moweb:</p>
                    </div>
                </div>
                <div className="row grid xl:grid-cols-4 lg:grid-cols-4 md:grid-cols-2 mb-10">
                    <div className="card p-5 md:p-5 lg:p-30 bg-white dark:bg-black rounded-10 border">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/fintech-industry/svg/ic-client-retention.svg"
                                width={36}
                                height={36}
                                alt="proven-agtech"
                            />
                        </div>

                        <p className="fs-md mb-0">92% client retention across banking and finance</p>
                    </div>
                    <div className="card p-5 md:p-5 lg:p-30 bg-white dark:bg-black rounded-10 border">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/fintech-industry/svg/ic-faster-go-to-market.svg"
                                width={36}
                                height={36}
                                alt="tangible business"
                            />
                        </div>
                        <p className="fs-md mb-0">35% faster go-to-market with our agile development process</p>
                    </div>
                    <div className="card p-5 md:p-5 lg:p-30 bg-white dark:bg-black rounded-10 border">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/fintech-industry/svg/ic-iso-certified.svg"
                                width={36}
                                height={36}
                                alt="AI + IoT Expertise"
                            />
                        </div>
                        <p className="fs-md mb-0">ISO-certified for secure and compliant software delivery</p>
                    </div>
                    <div className="card p-5 md:p-5 lg:p-30 bg-white dark:bg-black rounded-10 border">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/fintech-industry/svg/ic-clients-include-fortune.svg"
                                width={36}
                                height={36}
                                alt="clients-include-fortune"
                            />
                        </div>

                        <p className="fs-md mb-0">Clients include Fortune 500 finance leaders and high-growth startups</p>
                    </div>
                </div>
                <div className="row grid lg:grid-cols-12">
                    <div className="lg:col-span-10">
                        <h2 className="mb-3" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            Ready to Launch Your FinTech Product?
                        </h2>
                        <p className="mb-3">
                            Partner with a trusted fintech software development company that delivers secure, scalable, and
                            compliant solutions.
                        </p>
                        <div>
                            <Link href="/contact-us" className="btn btn-primary">
                                {'Get a Free Consultation'}
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WhyChooseMowebFintech;
